<div 
*ngIf="!isLoading"
class="flex flex-col justify-center items-center gap-8 xl:gap-12 w-full h-full text-[1.2rem] xl:text-[1.4rem] 2xl:text-[1.75rem]">

  <div class="flex flex-col gap-4 items-center justify-center text-dimot-1">
    <h2 class="text-[2.1rem] xl:text-[2.5rem] 2xl:text-[3rem] text-center">
      {{ formatNumber(experienceAndHospitals!.hosptialsTotalNumber) }}
    </h2>
    <h3 class="mb-2 text-[0.8rem] xl:text-[0.9rem] 2xl:text-[1rem] text-center">
      Centri Ospedalieri
    </h3>
  </div>


  <div class="h-[1px] w-[90%] bg-gray-200"></div>


  <div class="flex flex-col gap-4 items-center justify-center text-dimot-1">
    <h2 class="text-[2.1rem] xl:text-[2.5rem] 2xl:text-[3rem] text-center">
      {{ formatNumber(experienceAndHospitals.experienceTotal) }}
    </h2>
    <h3 class="mb-2 text-[0.8rem] xl:text-[0.9rem] 2xl:text-[1rem] text-center">
      Esperienze
    </h3>
  </div>

</div>

<!--<div 
*ngIf="!isLoading"
class="flex flex-col justify-center items-center gap-16 w-full h-[490px] text-[1.75rem]">

  <div class="flex flex-col items-center text-dimot-1">
    <h2 class="text-[3.8rem]">
      {{ formatNumber(experienceAndHospitals!.hosptialsTotalNumber) }}
    </h2>
    <h3 class="mb-2 text-[1.4rem]">
      Numero Centri Ospedalieri
    </h3>
  </div>

  <div class="w-full flex justify-center">
    <div class="w-[100%] h-[1px] bg-gray-200"></div>
  </div>

  <div class="flex flex-col items-center text-dimot-1">
    <h2 class="text-[3.8rem]">
      {{ formatNumber(experienceAndHospitals.experienceTotal ) }}
    </h2>
    <h3 class="mb-2 text-[1.4rem]">
      Numero Esperienze
    </h3>
  </div>

</div>

-->
